import React from "react";
import Button from "../Utils/Button";

export default function Footer() {
  return (
    <footer className="Footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4"></div>
          <div className="col-lg-4 col-md-6">
            <div className="Footer__Social">
              <p className="Footer__Social--title">social media</p>
              <div className="Footer__Social--media">
                <span className="Footer__Social--button">
                  <a
                    href="https://web.facebook.com/profile.php?id=100083048242232"
                    className="Footer__Social--link"
                    target={"_blank"}
                  >
                    <i class="bi bi-facebook"></i>
                  </a>
                </span>
                <span className="Footer__Social--button">
                  <a
                    href="https://twitter.com/beyond_limitsfa?s=11"
                    className="Footer__Social--link"
                    target={"_blank"}
                  >
                    <i class="bi bi-twitter"></i>
                  </a>
                </span>
                <span className="Footer__Social--button">
                  <a
                    href="https://instagram.com/beyondlimits_fa?igshid=YmMyMTA2M2Y="
                    // href="https://www.instagram.com/beyondlimits_fa/"
                    className="Footer__Social--link"
                    target={"_blank"}
                  >
                    <i class="bi bi-instagram"></i>
                  </a>
                </span>
                <span className="Footer__Social--button">
                  <a
                    href="https://www.youtube.com/results?search_query=beyond+limits"
                    className="Footer__Social--link"
                    target={"_blank"}
                  >
                    <i class="bi bi-youtube"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="Footer__Social">
              <p className="Footer__Social--title">contact us</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  marginTop: "15px",
                  border: "1px solid #fff",
                }}
              >
                <Button
                  text={"send request"}
                  div={{
                    padding: "5px 20px",
                    marginTop: "0",
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    transform: "none",
                  }}
                  link={{
                    fontSize: "1.6rem",
                    letterSpacing: "2px",
                    color: "#fff",
                    textTransform: "uppercase",
                  }}
                  url="/contact-us"
                />
              </div>
              <p className="Footer__Social--title">phone:</p>
              <p className="Footer__Social--open">open:</p>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          borderTop: "1px solid rgba(255,255,255,0.4)",
          marginTop: "50px",
        }}
      ></div>

      <div className="container">
        <div
          className="row"
          style={{
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <div className="col-md-12 Footer__Copyright">
            <p className="Footer__Copyright--policy">
              Beyond Limits Football Academy
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
